import CotizacionDatos from "./CotizacionDatos";
import type { GestionCotizacion } from "../hooks/useGestionCotizacion";

interface Props {
  gestion: GestionCotizacion;
}

export const GestionCotizacionContenido = ({ gestion }: Props) => {
  if (!gestion.cotizacion) return null;

  return (
    <CotizacionDatos
      verCotizacion={gestion.cotizacion}
      procesandoEnModal={gestion.procesando}
      proveedores={gestion.proveedores}
      // selección
      seleccion={gestion.seleccion}
      inventariosAutorizados={gestion.inventariosAutorizados}
      onToggleProducto={gestion.alternar}
      onMarcarSeleccionados={gestion.marcarSeleccionados}
      descripcion={gestion.descripcion}
      setDescripcion={gestion.setDescripcion}
      // recotización
      recotizacion={gestion.recotizacion}
      onCambiarRecotizacion={gestion.cambiarRecotizacion}
      onRecotizar={gestion.recotizarProductos}
      setCotizacionProductos={gestion.setCotizacionProductos}
      isAlertOpenProductosProveedor={gestion.isOpenProductosProveedor}
    />
  );
};
